import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Name = ({ name = '-' }) => {
	return (
		<Box display={'flex'} flexDirection={'column'}>
			<Box
				display={'flex'}
				alignItems={'left'}
				justifyContent={'flex-start'}
			>
				<Typography
					sx={{
						fontSize: '14px',
						fontWeight: '500',
					}}
				>
					{' '}
					{name ? name : '-'}{' '}
				</Typography>
			</Box>
		</Box>
	);
};

export default Name;
